import { gql } from 'apollo-boost';

export const cryptaSegmentFragment = gql`
    fragment CryptaSegmentFragment on GdCryptaSegment {
        id
        type
        name
        parentId
        description
        interestType
        canSelectAll
        mutuallyExclusiveIds
    }
`;

export const cryptaSegments = gql`
    query CryptaSegments($input: GdCryptaSegmentsContainerInput!) {
        reqId: getReqId
        cryptaSegments(input: $input) {
            totalCount
            rowset {
                ...CryptaSegmentFragment
            }
        }
    }
    ${cryptaSegmentFragment}
`;
